/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-label[_ngcontent-%COMP%]{color:#e56c11!important}.description-field[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap;max-width:20rem;text-overflow:ellipsis}"];
export { styles as styles };
